import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import AirportInput from '../components/AirportInput'
import { useClaimForm } from '../context/ClaimFormContext'
import { usePromo } from '../context/PromoContext'
import './steps.css'

function Step1Route() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { data, updateField } = useClaimForm()
  const { partnerLogo, partnerWebsite, hasPromo } = usePromo()

  const handleChange = (e) => {
    const { name, value } = e.target
    const dataField = name === 'departure' ? 'routeDepartureData' : 'routeDestinationData'
    const field = name === 'departure' ? 'routeDeparture' : 'routeDestination'
    updateField(field, value)
    updateField(dataField, null)
  }

  const handleSelect = (name, item) => {
    const dataField = name === 'departure' ? 'routeDepartureData' : 'routeDestinationData'
    const field = name === 'departure' ? 'routeDeparture' : 'routeDestination'
    updateField(field, item.Code)
    updateField(dataField, item)
  }

  const [showErrors, setShowErrors] = useState(false)

  const scrollToFirstInvalid = () => {
    setTimeout(() => {
      const el = document.querySelector('.field-error')
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        const input = el.parentElement?.querySelector('input, select, textarea')
        input?.focus({ preventScroll: true })
      }
    }, 0)
  }

  const handleSubmit = () => {
    if (!canProceed) {
      setShowErrors(true)
      scrollToFirstInvalid()
      return
    }
    sessionStorage.removeItem('claimform_upload_case_uuid')
    navigate('/step2', { state: { allowStep: '/step2' } })
  }

  const canProceed = data.routeDeparture && data.routeDestination

  return (
    <div className="step active">
      <button className="back-btn" style={{ opacity: 0, pointerEvents: 'none' }}>
        {t('common.back')}
      </button>
      <div className="step-tag">{t('step1.tag')}</div>
      <h2 className="step-h">{t('step1.title')}</h2>
      <p className="step-sub">{t('step1.subtitle')}</p>

      <h3 className="section-label">{t('step1.departure')}</h3>
      <div className="field">
        <AirportInput
          name="departure"
          placeholder={t('step1.departurePlaceholder')}
          value={data.routeDeparture}
          selectedItem={data.routeDepartureData}
          onChange={handleChange}
          onSelect={(item) => handleSelect('departure', item)}
        />
        {showErrors && !data.routeDeparture && (
          <div className="field-error">{t('step1.errorRequired')}</div>
        )}
      </div>

      <h3 className="section-label">{t('step1.destination')}</h3>
      <div className="field">
        <AirportInput
          name="destination"
          placeholder={t('step1.destinationPlaceholder')}
          value={data.routeDestination}
          selectedItem={data.routeDestinationData}
          onChange={handleChange}
          onSelect={(item) => handleSelect('destination', item)}
        />
        {showErrors && !data.routeDestination && (
          <div className="field-error">{t('step1.errorRequired')}</div>
        )}
      </div>

      <div className="btn-row" style={{ marginTop: 28 }}>
        <button className="btn-p" onClick={handleSubmit}>
          {t('common.continue')}
        </button>
      </div>
    </div>
  )
}

export default Step1Route
